//Request

export interface StepRequest {
  policyId: number | string;
  versionNum: number | string;
  EffectiveDate?: string;
  ExpirationDate?: string;
}

export interface InstallmentBillingAcceptStatusRequest {
  policyId: number;
  versionNum: number;
}
//Documents Response

export interface DocumentsResponse {
  SignatureMethod: string;
  AvailableDocuments: AvailableDocument[];
  Documents: any[];
  RequiredDocuments: RequiredDocument[];
  SummaryDetails: any;
}

export interface RequiredDocument {
  DocumentType: string;
  Due: string;
  Form: DocForm;
  Actions: Action[];
  Status: string;
}

export interface DocForm {
  Name: string;
}

export interface Action {
  ButtonType: string;
  PolicyId: number;
  VersionNum: number;
  FileName: string;
  FileURL: string;
  FormType: string;
  DocTypeName: string;
  FormName: string;
  FolderType: string;
  UCMFormId?: number;
}

//Response

export interface StepResponse {
  Errors?: any;
  Status?: string;
  Message?: string;
  ReturnObject?: any;
  PolicyId: number;
  PolicyTxnNum: number;
  PolicyTxnId: number;
  PolicyTypeId?: number;
  PendingEndorsementPolicyId?: string;
  PendingEndorsementVersionNum?: string;
  PendingEndorsementENReason: string;
  CurrentPolicyNum?: string;
  PriorPolicyNum?: string;
  SignatureMethod: string;
  SummaryDetails: SummaryDetails;
  PremiumDetails: PremiumDetails;
  CoverageDetails: CoverageDetails;
  OtherCoverageDetails: OtherCoverageDetails;
  InspectionDetails?: any;
  IsAdmitted?: boolean;
  IsPolicyNew: boolean;
  PaymentDetail: PaymentDetails;
  PolicyDetails: PolicyDetails;
  Coverages: Coverage[];
  Subjectivities: any[];
  AvailableDocuments: AvailableDocument[];
  Documents?: any[];
  RequiredDocuments?: any[];
  Payments?: any;
  UnderwritingDocumentsRequired: boolean;
  PolicyTransactions: PolicyTransaction[];
  ReviewAndSubmit?: ReviewAndSubmitData;
  CachedState: boolean;
  CancelInfo: CancelInfo  
}
export interface CancelInfo {
  CancelRequestBy:string;
  CancelReason:string;
  CancelType:string;
  CancelMethod:string;
  ReturnPremiumTo:string;
  EffectiveDate:Date;
  ProcessDate:Date;
  NoticeText:string;
}
export interface ReviewAndSubmitData {
  AdditionalInsuredFormType: string;
  AdditionalInsured: NameAndAddressData;
  AdditionalInsuredContact: AdditionalInsuredContact;
  TaxAndFeeItems: TaxAndFeeItem[];
  AdditionalPremiumDue: string;
  Total: string;
  SelectedForms: [];
}
export interface NameAndAddressData {
  NameAndAddress: string;
}
export interface AdditionalInsuredContact {
  ContactId: number;
  Name: string;
  PrimaryAddress: Address;
}
export interface PolicyTransaction {
  EffectiveDate: Date;
  PolicyNumber: string;
  PolicyId: number;
  VersionNum: number;
  Type: string;
  GrossPremium: string;
  Status: string;
}
export interface SummaryPendingItem {
  InsuredName: string;
  SubmissionStatus: string;
  SubmissionStatusDescription: string;
  SubmissionType: string;
  SubmissionId: string;
  Program: string;
  PolicyTotal: number;
  PolicyStatus: string;
  EffectiveDateOfChange?: string;
  EndorsementTotal?: string;
  EndorsementStatus?: string;
}

export interface SummaryBoundItem {
  InsuredName: string;
  SubmissionStatus: string;
  SubmissionStatusDescription: string;
  PolicyStatus: string;
  PolicyNumber: string;
  SubmissionType: string;
  Program: string;
  PolicyTotal: number;
  EffectiveDateOfChange?: string;
  EndorsementTotal?: string;
  EndorsementStatus?: string;
}

export interface SummaryDetails {
  SummaryPendingItem: SummaryPendingItem;
  SummaryBoundItem: SummaryBoundItem;
}

export interface PremiumItem {
  Name: string;
  Amount: number;
}

export interface TaxAndFeeItem {
  Name: string;
  Amount: number;
}

export interface PremiumDetails {
  PremiumItems: PremiumItem[];
  TaxAndFeeItems: TaxAndFeeItem[];
  PolicyTotal: number;
  PolicyTermStartDate: Date;
  PolicyTermEndDate: Date;
  PaymentDueDate: Date;
  PaymentPlan?: string;
}

export interface Limit {
  Name: string;
  Amount: number;
}

export interface Credit {
  Name: string;
}

export interface CoveragesIncludedAtNoCharge {
  Name: string;
  FormCode?: any;
  Version?: any;
  IncludedAtNoCharge: boolean;
}

export interface CoverageItem {
  Name: string;
  Description?: any;
  Amount?: number;
  Limits: Limit[];
  Credits: Credit[];
  CoveragesIncludedAtNoCharge: CoveragesIncludedAtNoCharge[];
  CoverageOptions?: any;
  SelectedOptionalForms?: any;
  IncludedOptions?: any[];
  AdditionalInformation?: any[];
  PollutionIncidentLiability?: any[];
}

export interface CoverageDetails {
  Name: string;
  CoverageItems: CoverageItem[];
}

export interface CoverageItem2 {
  Name: string;
  Description?: any;
  Amount: number;
  Limits?: any;
  Credits?: any;
  CoveragesIncludedAtNoCharge?: any;
  CoverageOptions?: any;
  SelectedOptionalForms?: any;
  IncludedOptions?: any[];
  CoverageOption?: string;
  AdditionalInformation?: any[];
  PollutionIncidentLiability?: any[];
}

export interface OtherCoverageDetails {
  CoverageItems: CoverageItem2[];
}

export interface PaymentDetails {
  InstallmentBillingOption: string[];
  PaperlessPremiumFinancing: string[];
  AgencyBill: string[];
  PaymentPlan: string[];
  MailPaymentTo: string[];
  OvernightMail: string[];
  WireTransferOrACH: string[];
  Contact: string[];
  PaymentDetails: string[];
}

export interface PhysicalAddress {
  AddressId: number;
  CountryCode: string;
  ZipCode: string;
  StreetAddress: string;
  StateCode: string;
  County: string;
  City: string;
  AddressTypes: number[];
  StreetNumber?: any;
  StreetName?: any;
  AddressToString: string;
}

export interface MailingAddress {
  AddressId: number;
  CountryCode: string;
  ZipCode: string;
  StreetAddress: string;
  StateCode: string;
  County: string;
  City: string;
  AddressTypes: number[];
  StreetNumber?: any;
  StreetName?: any;
  AddressToString: string;
}

export interface Insured {
  Name: string;
  DBA?: any;
  TypeOfBusiness: string;
  LicenseNumber: string;
  YearsOfExperience: number;
  Telephone: string;
  EmailAddress?: any;
  PhysicalAddress: PhysicalAddress;
  MailingAddress: MailingAddress;
  Website?: any;
}

export interface Address {
  AddressId?: number;
  StreetAddress: string;
  ZipCode: string;
  StateCode: string;
  City: string;
  CountryCode?: string;
  County?: string;
  AddressTypes?: number[];
  StreetNumber?: any;
  StreetName?: any;
  AddressToString?: string;
}

export interface Owner {
  Name: string;
  Address: Address;
  SocialSecurityNumber: string;
}

export interface Classification {
  Name: string;
  PercentOfOperation: number;
}

export interface Rating {
  CPLNumClaims?: number;
  PILNumClaims?: number;
  Classifications: Classification[];
  NumberOfOwners?: number;
  TotalPayroll: number;
  GrossReceipts: number;
  SubcontractorCosts: number;
  Pollution_PolicyType?: string;
  Pollution_Revenue?: string;
  Professional_PercentOfGrossRevDesignBuild?: string;
  Professional_GrossRevPastTwelveMonths?: string;
  Professional_EstGrossRevNextTwelveMonths?: string;
  BuildersRisk_SquareFootage?: string;
  // BuildersRisk_TIVCurrentStructure?: string;
  BuildersRisk_YearsOfExperienceGeneralContractor?: string;
  BuildersRisk_ProjectType?: string;
  BuildersRisk_TIVNewConstruction?: string;
  BuildersRisk_TIVCurrentStructure?: string;
  BuildersRisk_JobsiteAddress?: string;
  BuildersRisk_JobsiteProtectionClass?: string;
  BuildersRisk_JobsiteConstructionType?: string;
  BuildersRisk_JobsiteAgeOfStructure?: string;
  BuildersRisk_OccupancyYN?: string;
  BuildersRisk_ConstructionStartedYN?: string;
  BuildersRisk_HydrantYN?: string;
  BuildersRisk_SecuredAlarm?: string;
  BuildersRisk_SecuredFenced?: string;
  BuildersRisk_SecuredLighting?: string;
  BuildersRisk_SecuredNone?: string;
  BuildersRisk_SecuredWatchman?: string;
  ExcessLiability_TotalPayroll?: string;
  ExcessLiability_GrossReceipts?: string;
  ExcessLiability_SubcontractorCosts?: string;
  ExcessLiability_UnderlyingGeneralLiabilityCarrier?: string;
  ExcessLiability_EffectiveDate?: string;
  ExcessLiability_ExpirationDate?: string;
  ExcessLiability_Premium?: string;
  ExcessLiability_PerOccurrenceLimit?: string;
  ExcessLiability_PersonalAndAdvertisingInjury?: string;
  ExcessLiability_ProductsCompletedOperationsAggregate?: string;
  ExcessLiability_GeneralAggregate?: string;
  BuildersRisk_StoriesTall?: string;
}

export interface PolicyDetails {
  Insured: Insured;
  Owner: Owner;
  Rating: Rating;
}

export interface Limit2 {
  Name: string;
  Amount: number;
}

export interface Coverage {
  Name: string;
  Description?: string;
  Amount?: number;
  Limits?: Limit2[];
  Credits?: any;
  CoveragesIncludedAtNoCharge?: any;
  CoverageOptions?: any;
  SelectedOptionalForms?: any[];
  IncludedOptions?: any[];
  SubHeading: string;
  CoverageDetails?: any[];
  CoverageExtension?: any[];
  SupplementaryCoverages?: any[];
  LossPayeeMortgageeAdditionalInsured?: any[];
  UnderlyingCoverages?: any[];
}

export interface AvailableDocument {
  Name?: string;
  ApiPath: string;
  PaymentPlanId?: string;
  ImageRightPageId?: string;
  UCMFormId?: number;
}

export interface GetSLDocumentReq {
  FormName?: string;
  PolicyId: number;
  VersionNum: number;  
}

export interface CheckAutoDeclineResponse {
  DeclineReasons: Array<string>;
  DeclinationCode: string;
  AutoDecline: boolean;
  PolicyId: number;
  VersionNumber: number;
  PolicyTxnId: number;
  PolicyTotal: number;
  PolicyTypeId: number;
  Status: string;
  Warnings: Array<string>;
  Errors: Array<string>;
}
export interface AutoDeclineRequest {
  DeclineReasons: Array<string>;
  DeclinationCode: string;
  AutoDecline?: boolean;
  PolicyId?: number;
  VersionNumber?: number;
  PolicyTxnId: number;
  PolicyTotal?: number;
  PolicyTypeId: number;
}
export interface ReferralCheckRequest {
  PolicyId: number;
  VersionNumber: number;
  PolicyTypeId: number;
  loggedInUser: string;
}

export interface ReferralCheckResponse {
  PolicyId: number;
  VersionNumber: number;
  PolicyStatus: string;
  Status: string;
  Warnings: Array<string>;
  Errors: Array<string>;
  SubmissionType: string;
}
export interface ActivityLogRequest {
  ActivityType: string;
  Amount: any;
  Description: string;
  LoggedInUser: string;
  PolicyTxnId: number;
}
export interface ActivityLogResponse {
  Status?: string;
}

export interface AgencyBillingResponse {
  Status?: string;
  Message?: string;
  Warnings?: string[];
  Errors: string[];
}

export interface RedirectInstallmentBillingResponse {
  Input1InstallmentBillRedirectUrl: string;
  Status: string;
  Warnings: string[];
  Errors: string[];
}

export interface RedirectPremiumFinancingResponse {
  Input1PremiumFinancingFormPost: string;
  RedirectUrl: string;
  Status: string;
  Warnings: string[];
  Errors: string[];
}

export interface InstallmentBillingResponse {
  BoundPolicyNum: string;
  BoundAccountNumberInstallmentBill: string;
  FromInputOne: string;
  Transaction: string;
  TransactionDescription: string;
  Status: string;
  Warnings: string[];
  Errors: string[];
}

export interface PremiumFinancingResponse {
  BoundPolicyNum: string;
  BoundAccountNumberPremiumFinancing: string;
  FromInputOne: string;
  Transaction: string;
  TransactionDescription: string;
  Status: string;
  Warnings: string[];
  Errors: string[];
}

export interface SaveSignatureMethodRequest {
  PolicyId: number;
  VersionNum: number;
  SignatureMethod: string;
}

export interface QueryStringRequest {
  QueryStringFromInputOne: string;
}

export interface FormQuestion {
  Question: string;
  AnswerType: string;
  AnswerOptions?: string[];
  IsRequired: boolean;
}
export interface InsuredForm {
  FormId: number;
  FormName: string;
  FormCode: string;
  Version: string;
  UWFormId: number;
  IsChanged: boolean;
  IsAdded: boolean;
  IsUpdated: boolean;
  IsDeleted: boolean;
  AllowMultiples: boolean;
  FormQuestions: FormQuestion[];
}

export interface AvailableForms {
  AdditionalInsuredForms: InsuredForm[];
}
export interface CreateEndorsementResponse {
  PolicyId: number;
  TxnNum: number;
  PolicyTermNum?: number;
  PolicyTxnId?: number;
  CurrentPolicyNum?: string;
  PriorPolicyNum?: string;
  SubCompanyCode?: string;
  TxnEffectiveDate?: string;
  PolicyPortalStatus: string;
  Status?: string;
  Warnings?: string[];
  Errors?: string[];
}

export interface GoogleAnalyticResponse {
  Environment: string;
  ForgotPassword: any[];
  GoogleAnalytics: GoogleAnalytic;
  Status: string;
  Warnings: any[];
  Errors: any[];
}

export interface GoogleAnalytic {
  TrackingID: string;
}


export interface InstallmentBillingAcceptStatusResponse {
  PolicyId:number;
  VersionNumber:number;
  InstallmentBillingAccept:boolean;
  Status: string;
  Warnings: any[];
  Errors: any[];
}